module.exports = __webpack_public_path__ + "tickets_opened.6b54f73c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/analytics_icons/tickets_opened.png
// module id = 884
// module chunks = 0